// extracted by mini-css-extract-plugin
export default {"container":"RefundPolicyPage_container__TEbJD"};